import { create } from 'zustand';

/**
 * Debug console: logs every API request and WebSocket message so the
 * operator can inspect signaling without opening browser DevTools.
 */
export const useDebugStore = create(
  /** @param {import('zustand').SetStateFn<import('./debugStore.js').DebugState>} set */
  (set) => ({
    enabled: false,
    logs: /** @type {Array<{kind: string; ts: string; data: object}>} */ ([]),

    setEnabled: (enabled) => set({ enabled }),

    log: (kind, data) =>
      set((state) => ({
        logs: [
          ...state.logs.slice(-2000),
          { kind, ts: new Date().toISOString(), data },
        ],
      })),

    clear: () => set({ logs: [] }),
  }),
);

/** @typedef {{ enabled: boolean; logs: Array<{kind: string; ts: string; data: object}> }} DebugState */

/** Standalone helpers — api.js imports them via dynamic import (no cycle). */
let _api = /** @type {null|{log: (kind: string, data: object) => void}} */ (null);

export function logApi(data) {
  if (!_api) return;
  _api.log('api', data);
}

export function logWs(kind, data) {
  if (!_api) return;
  _api.log(kind, data);
}

/** Called once at app boot to register the store's log method. */
export function initDebugStore(log) {
  _api = { log };
}
